import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DontMatchOtherValidator = (otherControlName: string): ValidatorFn => {
  let thisControl: AbstractControl;
  let otherControl: AbstractControl;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) {
      return null;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as AbstractControl;
      if (!otherControl) {
        throw new Error('dontMatchOtherValidator(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => thisControl.updateValueAndValidity());
    }

    if (!otherControl) {
      return null;
    }

    if (otherControl.value === thisControl.value) {
      return {
        dontMatchOtherValidator: true,
      };
    }

    return null;
  };
};
